import React from 'react';

interface ChatSkeletonProps {
  count?: number;
}

const ChatSkeleton: React.FC<ChatSkeletonProps> = ({ count = 5 }) => {
  return (
    <div className="absolute w-full p-2 lg:p-3">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={`mb-4 flex items-start gap-2 ${
            index % 2 === 0 ? 'justify-start' : 'justify-end'
          }`}
        >
          {index % 2 === 0 && (
            <div className="w-5 h-5 lg:w-[1.8vw] lg:h-[1.8vw] rounded-full bg-gray-200 animate-pulse flex-shrink-0" />
          )}
          
          <div className={`max-w-[70%] ${index % 2 === 0 ? 'order-2' : 'order-1'}`}>
            <div className="bg-gray-200 rounded-2xl w-full h-[40px] animate-pulse">
                <div className="w-full h-[40px] opacity-0">
                    THIS IS A MESSAGE
                </div>
            </div>
          </div>
          
          {index % 2 !== 0 && (
            <div className="w-5 h-5 lg:w-[1.8vw] lg:h-[1.8vw] rounded-full bg-gray-200 animate-pulse flex-shrink-0 order-2" />
          )}
        </div>
      ))}
    </div>
  );
};

export default ChatSkeleton;
